/*--------------------------------------------------------------
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * See License.txt in the project root for license information.
 *--------------------------------------------------------------*/

import { Module, Node } from '@msdyn365-commerce-modules/utilities';
import React, { ReactNode } from 'react';

//@ts-ignore
import Slider from "react-slick";

import { IObrienSlideContainerViewProps } from './obrien-slide-container';




export class ObrienSlideContainerView extends React.PureComponent<IObrienSlideContainerViewProps> {

    

    constructor(props: IObrienSlideContainerViewProps) {
        super(props);
        this.state = {
            nav1: null,
            nav2: null
        };
    }

    componentDidMount() {
        this.setState({
            //@ts-ignore
            nav1: this.slider1,
            //@ts-ignore
            nav2: this.slider2
        });
      }
    

    public render(): JSX.Element {

        const { 
        
            slcategories, 
            SlideList, 
            SlideListItem,
            ctcategories,
            ContentList,
            ContentListItem,
            classNames
            
        } = this.props;

        return (
            <div className={classNames}>

                <Module {...ContentList}>
                    <Slider
                        //@ts-ignore
                        asNavFor={this.state.nav1}
                        //@ts-ignore
                        ref={slider => (this.slider2 = slider)}
                        slidesToShow={3}
                        swipeToSlide={true}
                        focusOnSelect={true}
                        centerMode={true}
                        arrows={false}
                        responsive={[
                            {
                              breakpoint: 868,
                              settings: {
                                slidesToShow: 1,
                                slidesToScroll: 1
                              }
                            }
                          ]}
                    >
                        
                        { slcategories.map((slcategory: ReactNode, index: number) => {
                            return (
                                <Node {...SlideListItem} key={index}>
                                    {slcategory}
                                </Node>
                            );
                        })}
                        
                    </Slider>
                </Module>

                <Module {...SlideList}>
                    <Slider
                        //@ts-ignore
                        asNavFor={this.state.nav2}
                        //@ts-ignore
                        ref={slider => (this.slider1 = slider)}
                        fade={true}
                        //adaptiveHeight={true}
                        slidesToShow={1}
                        slidesToScroll={1}
                        draggable={false}
                    >

                        { ctcategories.map((ctcategory: ReactNode, index: number) => {
                            return (
                                <Node {...ContentListItem} key={index}>
                                    {ctcategory}
                                </Node>
                            );
                        })}
                    
                    </Slider>
                </Module>

            </div>
    
        );
    }
    
};

export default ObrienSlideContainerView;
